export const environment = {
  baseAPI: 'https://securepay-backend-dev.getsecurepay.ai',
  ssoAdminBaseAPI: 'https://ssoadmin-api-dev.secureid-digital.com.ng',
  clientId: 'spay.dev.3',
  production: false,
  checkoutFrontendUrl:
    'https://securepay-dev-checkout.secureid-digital.com.ng/',
};
